export const getIsFetching = (state, { requestId }) =>
  state.get('fetching').has(requestId);
export const buildIsFetchingSelector = requestId => state =>
  getIsFetching(state, { requestId });
